import "../../../shared/utilities/form_review.js";

// require application/components/templates/personal_information // Cant include jst in es6

class FormModalReview extends FormReview {
  constructor(options) {
    super();
    this.options = options;
  }

  addReviewItem(formFields) {
    let reviewContent = [];
    if (this.options.event) {
      setupEventTitle(this.options.event);
      setupEventInformation(this.options.event);
    }
    setupPersonalInformation.bind(this)();
    setupGeneralFormReview.bind(this)();

    formFields.find(":input").each((i, item) => {
      if (Array.isArray(jQuery(item).data("preview")) && jQuery(item).data("preview").length) {
        let name = jQuery(item).parent().data("behaviour");
        reviewContent.push(
          window.JST["application/components/templates/" + name]({ preview: jQuery(item).data("preview") }),
        );
      }
    });

    this.el.append(reviewContent);
    this._disableInputs();

    function setupEventTitle(event) {
      let eventTitle = jQuery("<h3 class='form-review-title'>").append(event.name);
      reviewContent.push(eventTitle);
    }

    function setupEventInformation(event) {
      reviewContent.push(window.JST["application/components/templates/event_information"]({ event: event }));
    }

    function setupPersonalInformation() {
      reviewContent.push(
        window.JST["application/components/templates/personal_information"]({
          form: jQuery(formFields),
          name: this._getRegistrantName(formFields),
          addresses: this._parseAddresses(formFields),
        }),
      );
    }

    function setupGeneralFormReview() {
      let formCopy = this.cloneForm(formFields);
      this.removeFormInformation(formCopy);
      reviewContent.push(formCopy);
    }
  }

  cloneForm(formFields) {
    formFields.find(":input").each(storeValue);
    let newForm = formFields.clone();
    newForm.find(":input").each(setWithStoredValue);
    return newForm;

    function storeValue() {
      jQuery(this).attr("stored-value", jQuery(this).val());
    }

    function setWithStoredValue() {
      jQuery(this).val(jQuery(this).attr("stored-value"));
    }
  }

  resetReview() {
    this.el.empty();
  }

  // PRIVATE

  _getRegistrantName(formFields) {
    let names = [];
    let firstName = formFields.find("#first_name").val();
    let lastName = formFields.find("#last_name").val();
    if (firstName != null) {
      names.push(firstName);
    }
    if (lastName != null) {
      names.push(lastName);
    }
    return names.join(" ");
  }

  _parseAddresses(formFields) {
    let addresses = [];
    formFields.find(".field-input").each(getAddress);
    return addresses;

    function getAddress(i, element) {
      let $element = jQuery(element);

      if (!$element.find('[id*="_street"]').length) {
        return;
      }

      let address = {
        street: $element.find('[id*="_street"]').val(),
        city: $element.find('[id*="_city"]').val(),
        state: $element.find('[id*="_state"]').val(),
        zip: $element.find('[id*="_zip_code"]').val(),
      };

      let header = jQuery(`<p class='form-review-subtitle'>${$element.find(".field-label").first().text()}</p>`);
      let street = jQuery(`<p class="form-review-address-street">${address.street}</p>`);
      let secondLine = jQuery(
        `<p class="form-review-address-location">${address.city}, ${address.state}, ${address.zip}</p>`,
      );

      addresses.push(jQuery('<div class="form-review-address">').append(header, street, secondLine));
    }
  }

  removeFormInformation(form) {
    let removeItems = [
      "#first_name",
      "#last_name",
      "#phone_number",
      "#email_address",
      '[id*="_street"]',
      ".field-header",
      ".sessions-input",
    ];
    form.find(".field-input").each(shouldItemBeRemoved);

    function shouldItemBeRemoved(i, input) {
      let inputItem = jQuery(input);
      removeItems.forEach(removePersonalInputs);

      function removePersonalInputs(item) {
        if (inputItem.find(item).length) {
          inputItem.remove();
        }
      }
    }
  }
}

window.FormModalReview = FormModalReview;
